import React from 'react'
import styles from './styles.module.css'
import { CustomInput } from '../../../assets/CustomInput/CustomInput'

const categoryAplicant = [
    "граждане РФ, не проходившие военную службу, - в возрасте от 16 до 22 лет",
    "граждане РФ, прошедшие военную службу, и военнослужащие, проходящие военную службу по призыву, - до достижения ими возраста 24 лет",
    "военнослужащие, проходящие военную службу по контракту (кроме офицеров), - по истечении половины срока военной службы, указанного в первом контракте, для получения высшего", "образования,-до достижения ими возраста 25 лет",
    "военнослужащие, проходящие военную службу по контракту (кроме офицеров), - по истечении половины срока военной службы, указанного в первом контракте, для получения среднего", "профессионального образования,-до достижения ими возраста 30 лет",
    "кандидаты из числа офицеров",
    "кандидаты из числа иностранных граждан"];

const status = [{
    id: 0,
    name: 'Не зачислен'
}, {
    id: 1,
    name: 'Зачислен'
}];

const Index = ({filters, setFilters, studyYears, edu_program, faculty = [], trainingDirect}) => {
    const handleChange = (e) => {
        setFilters({...filters, [e.target.name]: e.target.value});
    }

  return (
    <div className={styles.filters}>
        <CustomInput
        label='Дата с'
        value={filters.date_from}
        name='date_from'
        onChange={handleChange}
        type='date'
        />
        <CustomInput
        label='Дата по'
        value={filters.date_to}
        name='date_to'
        onChange={handleChange}
        type='date'
        />

        <div className={styles.select}>
        <label htmlFor='studyyear'> Год набора: </label>
        <select name='studyyear' onChange={handleChange}>
            <option value=''>Все</option>
            {studyYears.map(f => <option value={f.xp_key} key={f.xp_key}>{f.name}</option>)}
        </select>
        </div>

        <div className={styles.select}>
        <label htmlFor='isSCANstudent'> Зачисление: </label>
        <select name='isSCANstudent' onChange={handleChange}>
            <option value=''>Все</option>
            {status.map(f => <option value={f.id} key={f.id}>{f.name}</option>)}
        </select>
        </div>

        <div className={styles.select}>
        <label htmlFor='category_aplicant'> Категория кандидата: </label>
        <select name='category_aplicant' onChange={handleChange}>
            <option value=''>Все</option>
            {categoryAplicant.map(f => <option value={f} key={f}>{f}</option>)}
        </select>
        </div>

        <div className={styles.select}>
        <label htmlFor='edu_program'> Поступление на обр. прогр.: </label>
        <select name='edu_program' onChange={handleChange}>
            <option value=''>Все</option>
            {edu_program.map(f => <option value={f.ps_id} key={f.ps_id}>{f.name}</option>)}
        </select>
        </div>
        
        <div className={styles.select}>
        <label htmlFor='faculty'> Факультет: </label>
        <select name='faculty' onChange={handleChange}>
            <option value=''>Все</option>
            {faculty.map(f => <option value={f.idfaculty} key={f.idfaculty}>{f.faculty}</option>)}
        </select>
        </div>

        <div className={styles.select}>
        <label htmlFor='training_direct'> Направление подготовки: </label>
        <select name='training_direct' onChange={handleChange}>
            <option value=''>Все</option>
            {trainingDirect.map(f => <option value={f.training_direct_id} key={f.training_direct_id}>{f.training_direct}</option>)}
        </select>
        </div>
        
        
        
        

    </div>
  )
}

export default Index